import { UseNotificationReturn } from '../notification.types';
import { GhostButton } from '@components/form/button/ghost-button';
import { capitalizeFirst } from '@shared/utils/capitalize';
import { useTranslation } from 'react-i18next';
import { RiCheckDoubleLine } from 'react-icons/ri';

type Props = {
  markAllRead: UseNotificationReturn['markAllRead'];
  showMarkAll: boolean;
};

export function NotificationHeader(props: Props) {
  const {
    markAllRead: { loading, markAllRead },
    showMarkAll,
  } = props;
  const { t } = useTranslation();

  return (
    <div className="bg-primary-50 px-4 py-3 border-b border-b-gray-700">
      <div className="flex items-center justify-between">
        <p className="lg:text-xl text-text-950 leading-6.25 capitalize!">{t('notification_other')}</p>
        <GhostButton
          hidden={!showMarkAll}
          type="text"
          className="hover:scale-105 transition-all"
          icon={<RiCheckDoubleLine size={15} style={{ color: 'var(--color-primary-400)' }} />}
          loading={loading}
          onClick={() => markAllRead()}
        >
          <p className="text-primary-400">{capitalizeFirst(t('mark_all_as_read'))}</p>
        </GhostButton>
      </div>
    </div>
  );
}
